import React from 'react';
import '@xyflow/react/dist/style.css';
import { ColorModeProvider } from './contexts/ColorModeContext';
import { InspectProvider } from './contexts/InspectContext';
import { initJ2S } from 'react-jump2source';
import { useEffect } from 'react';
import NestedFlowDemo from './containers/DemoFlow2';
import { ThemeProvider } from './ThemeProvider';
import { RuntimeConfigProvider } from './contexts/RuntimeConfigContext';
import NestedFileFlowDeep from './containers/NestedFileFlowDeep';
import { trackPageView } from './services/analytics';

const App = () => {
  // Initialize Google Analytics only if consent was given
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      // Initialize GA only after consent
      import('./services/analytics').then(({ initGA }) => {
        initGA();
        trackPageView(window.location.pathname);
      });
    }
  }, []);

  // Only import and use react-jump2source in development
	useEffect(() => {
		if (process.env.NODE_ENV === 'development') {
			initJ2S({
				projectDir: process.env.REACT_APP_J2S_WORKSPACE_ROOT || '',
				resolver: process.env.REACT_APP_J2S_RESOLVER as 'cursor' | 'vscode',
			});
		}
	}, []);

  return (
    <ThemeProvider>
      <ColorModeProvider>
        <RuntimeConfigProvider>
          <InspectProvider>
            {process.env.REACT_APP_DEMO_MODE === 'true' ? <NestedFlowDemo /> : <NestedFileFlowDeep />}
          </InspectProvider>
        </RuntimeConfigProvider>
      </ColorModeProvider>
    </ThemeProvider>
  );
};
 
export default App;